import Sg_Utils from '../../sg_utils/sg_utils';

var Sg_Social = Sg_Social || {};
/**
 * @class
 */
export default Sg_Social = (function () {
    'use strict';

    var isCurrentWindowAnIframe = function () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    };

    var isUserAgentIOS = function () {
        return /iP(ad|hone|od)/.test(navigator.userAgent) && !window.MSStream;
    };

    return {
        recaptchaLoaded: false,
        recaptchasToLoad: [],

        options: {
            sg_share_baseurl: window.location.origin,
            sg_redirect_uri: window.location.href,

            fb_app_id: '',

            twitter_username: '',

            lang: 'br',
            share_email_endpoint: '/share_email/',

            campaign: {
                enabled: true,
            },
        },

        blocks: [],

        init: function (options) {
            window.recaptchaloaded = function () {
                Sg_Social.recaptchaloaded();
            };

            this.initOptions(options);
            this.fetchAllBlocks();
            this.fetchAllButtonsFromBlocks();
        },

        initOptions: function (options) {
            this.options = Object.assign(this.options, options);
        },

        initButtons: function (buttons, block) {
            var sg_social = this;

            for (var index in buttons) {
                var button = buttons[index];

                if (Sg_Utils.hasClass(button, 'sg-facebook-btn')) button.sg_type = 'facebook';
                else if (Sg_Utils.hasClass(button, 'sg-twitter-btn')) button.sg_type = 'twitter';
                else if (Sg_Utils.hasClass(button, 'sg-email-btn')) button.sg_type = 'email';
                else if (Sg_Utils.hasClass(button, 'sg-whatsapp-btn')) button.sg_type = 'whatsapp';
                else if (Sg_Utils.hasClass(button, 'sg-print-btn')) button.sg_type = 'print';
                else if (Sg_Utils.hasClass(button, 'sg-linkedin-btn')) button.sg_type = 'linkedin';
                else if (Sg_Utils.hasClass(button, 'sg-sms-btn')) button.sg_type = 'sms';
                else if (Sg_Utils.hasClass(button, 'sg-pinterest-btn'))
                    button.sg_type = 'pinterest';
                else if (Sg_Utils.hasClass(button, 'sg-fbmessenger-btn'))
                    button.sg_type = 'fbmessenger';
                else if (Sg_Utils.hasClass(button, 'sg-vkontakte-btn'))
                    button.sg_type = 'vkontakte';
                else if (Sg_Utils.hasClass(button, 'sg-odnoklassniki-btn'))
                    button.sg_type = 'odnoklassniki';
                else if (Sg_Utils.hasClass(button, 'sg-telegram-btn')) button.sg_type = 'telegram';
                else continue;

                if (isUserAgentIOS() && button.sg_type === 'sms') {
                    var div = button.parentNode;
                    div.parentNode.removeChild(div);
                    continue;
                }
                
                Sg_Utils.addListener(button, 'click', function (e) {
                    var type = this.sg_type;
                    var params = [];
                    var windowFeatures = [];
                    var base_share = '';

                    var sgWindowOptions = {
                        enabled: false,
                        width: 1,
                        height: 1,
                        timeout: 0,
                    };

                    var block_url = block.url;
                    if (
                        (!block_url ||
                            block_url === '' ||
                            block_url === null ||
                            block_url === undefined) &&
                        block.urlCallback
                    ) {
                        if (typeof window[block.urlCallback] === 'function') {
                            var cb = window[block.urlCallback];
                            block_url = cb();
                            if (
                                typeof block_url === 'string' &&
                                block_url !== '' &&
                                block_url.charAt(0) === '/'
                            ) {
                                block_url = sg_social.options.sg_share_baseurl + block_url;
                            }
                        }
                    }

                    var url = block_url;
                    if (sg_social.options.campaign.enabled) {
                        url +=
                            (url.indexOf('?') > -1 ? '&' : '?') +
                            'utm_source=' +
                            type +
                            '&' +
                            'utm_medium=referral';
                    }
                    var url_decoded = url;
                    url = encodeURIComponent(url);

                    var body = '';
                    if (block.text) body += block.text;
                    if (url_decoded) body += (block.text ? '\n\n' : '') + url_decoded;

                    switch (type) {
                        case 'pinterest':
                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 750;
                            sgWindowOptions.height = 600;
                            base_share = 'https://www.pinterest.com/pin/create/button/?';

                            var pinterest_text =
                                encodeURIComponent(
                                    block.text.substring(0, 485 - block_url.length)
                                ) +
                                ' (...) ' +
                                block_url;
                            if (pinterest_text === ' (...) ') pinterest_text = '';
                            params.push('description=' + pinterest_text);
                            params.push('url=' + url);
                            params.push('media=' + encodeURIComponent(block.media));
                            break;

                        case 'email':
                            base_share = 'mailto:?';

                            if (block.title) {
                                params.push('subject=' + block.title);
                            }

                            params.push('body=' + encodeURIComponent(body));
                            break;

                        case 'facebook':
                            base_share = 'https://www.facebook.com/sharer/sharer.php?';

                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 556;
                            sgWindowOptions.height = 600;

                            params.push('u=' + url);
                            break;

                        case 'fbmessenger':
                            base_share = 'https://www.facebook.com/dialog/send?';

                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 750;
                            sgWindowOptions.height = 520;

                            params.push('app_id=' + Sg_Social.options.fb_app_id);
                            params.push('display=popup');
                            params.push('link=' + url);
                            params.push(
                                'redirect_uri=' +
                                    encodeURIComponent(Sg_Social.options.sg_redirect_uri)
                            );
                            break;

                        case 'googleplus':
                            base_share = 'https://plus.google.com/share?';

                            sgWindowOptions.width = 750;
                            sgWindowOptions.height = 520;

                            params.push('url=' + url);

                            break;

                        case 'print':
                            window.print();
                            break;

                        case 'sms':
                            base_share += 'sms:?';

                            params.push('body=' + encodeURIComponent(body));
                            break;

                        case 'twitter':
                            base_share = 'https://twitter.com/intent/tweet?';

                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 535;
                            sgWindowOptions.height = 461;

                            var max_chars = 140;
                            var short_url_length = 23;
                            var twitter_text;

                            if (block.twittercopy) {
                                twitter_text = block.twittercopy;
                            } else {
                                twitter_text =
                                    block.text.substring(0, max_chars - short_url_length - 7) +
                                    ' (...)';
                            }
                            if (twitter_text === ' (...)') twitter_text = '';
                            params.push('url=' + url);
                            params.push('text=' + encodeURIComponent(twitter_text));

                            if (Sg_Social.options.twitter_username) {
                                params.push('via=' + Sg_Social.options.twitter_username);
                            }
                            break;

                        case 'linkedin':
                            base_share = 'https://www.linkedin.com/shareArticle?';

                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 550;
                            sgWindowOptions.height = 560;

                            params.push('mini=true');
                            params.push('url=' + url);

                            break;

                        case 'whatsapp':
                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 550;
                            sgWindowOptions.height = 400;

                            body = '';
                            if (block.title) {
                                body += block.title;
                            }

                            if (url_decoded) {
                                body += (block.title ? '\n' : '') + url_decoded;
                            }

                            base_share = 'https://api.whatsapp.com/send?';
                            params.push('text=' + encodeURIComponent(body));

                            break;

                        case 'telegram':
                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 550;
                            sgWindowOptions.height = 400;

                            base_share = 'https://telegram.me/share/url?';
                            params.push('url=' + url);
                            params.push('text=' + encodeURIComponent(block.title || ''));
                            break;

                        case 'vkontakte':
                            sgWindowOptions.enabled = true;

                            base_share = 'http://vk.com/share.php?';
                            params.push('url=' + encodeURIComponent(block_url));
                            break;

                        case 'odnoklassniki':
                            sgWindowOptions.enabled = true;
                            sgWindowOptions.width = 550;

                            base_share = 'https://connect.ok.ru/offer?';
                            params.push('url=' + encodeURIComponent(block_url));
                            params.push('text=' + encodeURIComponent(block.title || ''));
                            if (block.media) {
                                params.push('imageUrl=' + encodeURIComponent(block.media));
                            }
                            break;

                        default:
                            return;
                    }

                    if (!params) {
                        return;
                    }

                    windowFeatures.push('width=' + sgWindowOptions.width);
                    windowFeatures.push('height=' + sgWindowOptions.height);
                    windowFeatures = windowFeatures.join();

                    url = base_share + params.join('&');

                    if (sgWindowOptions.enabled === true && !Sg_Utils.userAgentIsMobile()) {
                        window.open(url, '', windowFeatures.length === 0 ? '' : windowFeatures);
                    } else {
                        var target = sgWindowOptions.enabled ? '_blank' : '_self';
                        if (isCurrentWindowAnIframe()) {
                            target = '_parent';
                        }

                        window.open(url, target);
                    }

                    if (typeof gtag !== 'undefined') {
                        gtag('event', type, {
                            event_category: 'Sg_Social',
                            event_label: block_url,
                        });
                    } else if (typeof ga !== 'undefined') {
                        ga('send', 'event', 'Sg_Social', type, block_url, true);
                    }
                });
            }
        },

        fetchAllButtonsFromBlocks: function () {
            for (var index in this.blocks) {
                var block = this.blocks[index],
                    buttons = block.element.querySelectorAll('.sg-social button');

                this.initButtons(buttons, block);

                block.element.className = block.element.className.replace(
                    /\bsg-social-hidden\b/,
                    ''
                );
            }
        },

        fetchAllBlocks: function () {
            var sg_social = this;

            Sg_Utils.forEachElement('.sg-social', function (element, index) {
                /*
                 Title
                 */
                var title = element.getAttribute('data-title');

                /*
                 URL
                 */
                var url = element.getAttribute('data-url');
                if (!url) {
                    var dataUrlSelectorId = element.getAttribute('data-url-selector-id');
                    if (dataUrlSelectorId) {
                        var url_selector = document
                            .getElementById(dataUrlSelectorId)
                            .querySelectorAll('a');
                        if (url_selector.length == 1) {
                            url = url_selector[0].getAttribute('href');

                            if (!title) {
                                title = url_selector[0].textContent;
                            }
                        }
                    }
                }
                if (typeof url == 'string' && url !== '' && url.charAt(0) === '/') {
                    url = sg_social.options.sg_share_baseurl + url;
                }

                /*
                 URL Callback
                 */
                var urlCallback = element.getAttribute('data-url-callback');

                /*
                 Twitter Copy Text
                 */
                var twittercopy = element.getAttribute('data-twitter-copy');

                /*
                 Text
                 */
                var text = element.getAttribute('data-text');
                if (!text) {
                    var text_from_selector = element.getAttribute('data-text-selector-id');
                    if (text_from_selector) {
                        var text_selector = document.getElementById(text_from_selector);
                        if (text_selector && text_selector.innerText)
                            text = text_selector.innerText;
                    } else {
                        text = '';
                    }
                }

                /*
                 Media
                 */
                var media = element.getAttribute('data-media');

                /*
                 Done
                 */
                sg_social.blocks[index] = {
                    element: element,
                    title: title,
                    url: url,
                    urlCallback: urlCallback,
                    twittercopy: twittercopy,
                    text: text,
                    media: media,
                };
            });
        },
    };
})();

window.Sg_Social = Sg_Social
